import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d9974d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "MFormularioAtividadeComAtributos" }

import { onMounted, onUnmounted } from "vue";
  import {
    CaracteristicaComValor,
    OCaracteristicaValor,
  } from "@/components/AtributoComValor"
  import { AtributoBase } from "@/repositorios/atributos/atributos.modelos";

  import { useI18n } from "vue-i18n"
  import { CaracteristicaStore } from "@/store/atributos/caracteristicas/caracteristicas.store";
  import { storeToRefs } from "pinia";

  import SessaoServico from "@/servicos/sessao.service"

  enum ModoDeFormulario {
    EDICAO = "edicao",
    VISUALIZACAO = "visualizacao",
    CRIACAO = "criacao",
  }

  interface Props {
    atributosEsperados?: AtributoBase[]
    listaDeAtributosCaracteristicaComValor?: CaracteristicaComValor[]
    desabilitarCampos?: boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MFormularioAtividadeComAtributos',
  props: {
    atributosEsperados: null,
    listaDeAtributosCaracteristicaComValor: null,
    desabilitarCampos: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    atributosEsperados?: AtributoBase[]
    listaDeAtributosCaracteristicaComValor?: CaracteristicaComValor[]
    desabilitarCampos?: boolean
  }

  

  const { t } = useI18n()

  const caracteristicaStore = CaracteristicaStore()
  const { caracteristicas } = storeToRefs(caracteristicaStore)


  /**
   * @description o carregamento desse formulário depende de 3 modos possíveis de uso:
   * - EDICAO: ao editar uma atividade, é necessário combinar os atributosEsperados com a 
   * listaDeAtributosCaracteristicaComValor, formando uma única estrutura de dados. 
   * Veja na função: carregarFormularioEdicao()
   * 
   * - VISUALIZACAO: ao visualizar uma atividade, apenas a listaDeAtributosCaracteristicaComValor é necessária
   * pois todas as informações para visualização já estão nela. 
   * Veja na função: carregarFormularioVisualizacao()
   * 
   * - CRIACAO: ao criar uma atividade, os atributosEsperados são todas as informaçóes que devem ser preenchidas
   * para criar uma atividade com atributos.
   * Veja na função: carregarFormularioCriacao()
   */

  const carregarFormularioEdicao = (): void => {
    const atributosCombinados = props.listaDeAtributosCaracteristicaComValor!.map((caracteristica: CaracteristicaComValor) => {
      const atributoEsperado = props.atributosEsperados!.find((atributo: AtributoBase) => atributo.id === caracteristica.id)
      return {
        ...caracteristica,
        ...atributoEsperado,
      }
    })

    atributosCombinados.forEach((atributoCombinado: any) => {
      const caracteristicaJaExiste = caracteristicaStore.buscarCaracteristicaPorId(atributoCombinado.id)
      if (!caracteristicaJaExiste) {
        caracteristicaStore.adicionarCaracteristica({
          id: atributoCombinado.id,
          nomeDoAtributo: atributoCombinado.nomeDoAtributo,
          tipoDoAtributo: atributoCombinado.tipoDoAtributo,
          valor: atributoCombinado.valor,
          tipoDoValor: atributoCombinado.tipoDeValor,
          tipoDosValoresDaLista: atributoCombinado.tipoDosValoresDaLista,
          valoresPossiveis: atributoCombinado.valoresPossiveis,
          listaDeMultiplaEscolha: atributoCombinado.listaDeMultiplaEscolha,
          deletavel: atributoCombinado.deletavel,
        })
      }
    })
  }

  const carregarFormularioCriacao = (): void => {
    props.atributosEsperados!.forEach((atributo: AtributoBase) => {
      const caracteristicaJaExiste = caracteristicaStore.buscarCaracteristicaPorId(atributo.id!)
      if (!caracteristicaJaExiste) {
        const valorInicial = ""

        caracteristicaStore.adicionarCaracteristica({
          id: atributo.id!,
          nomeDoAtributo: atributo.nome,
          valor: valorInicial,
          tipoDoValor: atributo.tipoDeValor,
          tipoDoAtributo: "caracteristica",
          tipoDosValoresDaLista: atributo.tipoDosValoresDaLista,
          valoresPossiveis: atributo.valoresPossiveis,
          listaDeMultiplaEscolha: false,
          deletavel: false,
        })
      }
    })
  }

  const carregarFormularioVisualizacao = (): void => {
    props.listaDeAtributosCaracteristicaComValor!.forEach((caracteristica: CaracteristicaComValor) => {
      const caracteristicaJaExiste = caracteristicaStore.buscarCaracteristicaPorId(caracteristica.id)
      if (!caracteristicaJaExiste) {
        caracteristicaStore.adicionarCaracteristica({
          id: caracteristica.id,
          nomeDoAtributo: caracteristica.nomeDoAtributo,
          tipoDoValor: caracteristica.tipoDoValor,
          valoresPossiveis: caracteristica.valor as string[],
          valor: caracteristica.valor,
          deletavel: false,
          tipoDosValoresDaLista: caracteristica.tipoDosValoresDaLista,
          listaDeMultiplaEscolha: caracteristica.listaDeMultiplaEscolha,
        })
      }
    })
  }

  const modoDeFormulario = (): ModoDeFormulario => {
    const temTributosPreenchidos = 
      props.listaDeAtributosCaracteristicaComValor !== undefined && 
      props.listaDeAtributosCaracteristicaComValor.length > 0

    const temAtributosEsperados = 
      props.atributosEsperados !== undefined && 
      props.atributosEsperados.length > 0

    if (temTributosPreenchidos && temAtributosEsperados) {
      return ModoDeFormulario.EDICAO
    }

    if (temTributosPreenchidos && !temAtributosEsperados) {
      return ModoDeFormulario.VISUALIZACAO
    }

    return ModoDeFormulario.CRIACAO
  }

  const ordenarCaracteristicasPorOrdemAlfabetica = () => {
    caracteristicaStore.caracteristicas.sort((a, b) => {
      return a.nomeDoAtributo!.localeCompare(b.nomeDoAtributo!)
    })
  }

onMounted(() => {
  if (modoDeFormulario() === ModoDeFormulario.EDICAO) {
    carregarFormularioEdicao()
  } else if (modoDeFormulario() === ModoDeFormulario.VISUALIZACAO) {
    carregarFormularioVisualizacao()
  } else {
    carregarFormularioCriacao()
  }
  ordenarCaracteristicasPorOrdemAlfabetica()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(caracteristicas), (caracteristica) => {
      return (_openBlock(), _createElementBlock("div", {
        key: caracteristica.nomeDoAtributo,
        class: "MFormularioAtividadeComAtributos__Lista"
      }, [
        _createVNode(_unref(OCaracteristicaValor), {
          modelValue: caracteristica.valor,
          "onUpdate:modelValue": ($event: any) => ((caracteristica.valor) = $event),
          class: "MFormularioAtividadeComAtributos__Caracteristica",
          "data-testid": "MFormularioAtividadeComAtributos__Caracteristica",
          "lista-de-multipla-escolha": caracteristica.listaDeMultiplaEscolha,
          nome: caracteristica.nomeDoAtributo,
          "tipo-de-valor": caracteristica.tipoDoValor,
          "valores-possiveis": caracteristica.valoresPossiveis,
          "desabilitar-campo": __props.desabilitarCampos,
          "modo-leitura": modoDeFormulario() === ModoDeFormulario.VISUALIZACAO
        }, null, 8, ["modelValue", "onUpdate:modelValue", "lista-de-multipla-escolha", "nome", "tipo-de-valor", "valores-possiveis", "desabilitar-campo", "modo-leitura"])
      ]))
    }), 128))
  ]))
}
}

})